import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import axios from "axios"
import { PageSEO } from "@/components/page-seo"
import { Button } from "@/components/ui/button"
import { API_BASE } from "@/config/api"
import { formatRon } from "@/lib/format"
import { toast } from "sonner"

export default function PayInvoice() {
  const { t } = useTranslation()
  const { token } = useParams()
  const [inv, setInv] = useState(null)

  useEffect(() => {
    if (!token) return
    axios
      .get(`${API_BASE}/public/pay/${token}`)
      .then((r) => setInv(r.data))
      .catch(() => toast.error(t("public.payInvoice.notFound")))
  }, [token, t])

  const payStripe = async () => {
    try {
      const { data } = await axios.post(`${API_BASE}/public/pay/${token}/checkout`)
      if (data.url) window.location.href = data.url
      else toast.info(data.message || t("public.payInvoice.checkoutUnavailable"))
    } catch {
      toast.error(t("public.payInvoice.checkoutFailed"))
    }
  }

  if (!inv) {
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground">
        <PageSEO seoKey="payInvoice" />
        {t("public.payInvoice.loading")}
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <PageSEO seoKey="payInvoice" />
      <div className="max-w-md w-full rounded-2xl border border-border bg-card p-8">
        {inv.logo_url && <img src={inv.logo_url} alt="" className="h-10 mb-4 object-contain" />}
        <h1 className="font-display text-2xl tracking-tight font-medium">{inv.practice_name}</h1>
        <p className="text-sm text-muted-foreground mt-1">{t("public.payInvoice.invoiceLabel", { number: inv.number })}</p>
        <p className="text-sm mt-4">{t("public.payInvoice.client", { name: inv.client_name })}</p>
        <p className="font-display text-3xl mt-6">{formatRon(inv.amount)}</p>
        <p className="text-xs text-muted-foreground mt-1 capitalize">
          {t("public.payInvoice.status", { status: inv.status })}
        </p>
        {inv.status !== "paid" && (
          <Button className="w-full rounded-full mt-8" onClick={payStripe}>
            {t("public.payInvoice.payOnline")}
          </Button>
        )}
        {inv.bank_transfer?.iban && (
          <div className="mt-6 text-xs text-muted-foreground border-t pt-4">
            <p className="font-medium text-foreground">{t("public.payInvoice.bankTransfer")}</p>
            <p>{t("public.payInvoice.iban", { iban: inv.bank_transfer.iban })}</p>
            {inv.bank_transfer.bank && <p>{inv.bank_transfer.bank}</p>}
          </div>
        )}
      </div>
    </div>
  )
}
